import ReactGA4 from 'react-ga4';

const TRACKING_ID = 'G-B6TFNWM116';

const InitializeGoogleAnalytics = () => {
  ReactGA4.initialize(TRACKING_ID);
};

const TrackGoogleAnalyticsEvent = (
  category: string,
  action: string,
  label: string,
) => {
  ReactGA4.event({
    category: category,
    action: action,
    label: label,
  });
};

export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent };
